import { createContext, useState, useContext, useEffect } from 'react';

const FiltersContext = createContext({});

const STORAGE_KEY = '@portal-due-it/filters';

// Mesmas faixas aceitas pela API (IndexApprovedProjectsService).
const PRICE_FILTERS = [
  { value: 'all', label: 'Todos' },
  { value: 'free', label: 'Grátis' },
  { value: 'u10', label: 'Até R$ 10' },
  { value: '10-30', label: 'R$ 10 – 30' },
  { value: '30plus', label: 'R$ 30+' },
];

const SORT_OPTIONS = [
  { value: 'relevant', label: 'Mais relevantes' },
  { value: 'recent', label: 'Mais recentes' },
  { value: 'popular', label: 'Mais populares' },
  { value: 'downloads', label: 'Mais baixados' },
];

function loadStoredFilters() {
  try {
    const json = localStorage.getItem(STORAGE_KEY);
    return json ? JSON.parse(json) : {};
  } catch {
    return {};
  }
}

const FiltersProvider = ({ children }) => {
  // Os filtros salvos entram já no estado inicial, e não por efeito: um efeito
  // roda depois dos efeitos das telas, e sobrescreveria um `resetFilters` feito
  // na montagem (era o que fazia os Favoritos abrirem com o filtro da busca
  // anterior).
  const [stored] = useState(loadStoredFilters);

  const [currentPage, setCurrentPage] = useState(stored.currentPage || 1);
  const [selectedMaterials, setSelectedMaterials] = useState(
    stored.selectedMaterials || []
  );
  const [selectedCategories, setSelectedCategories] = useState(
    stored.selectedCategories || []
  );
  const [searchString, setSearchString] = useState(stored.searchString || '');
  const [premium, setPremium] = useState(stored.premium || false);
  const [price, setPrice] = useState(stored.price || 'all');
  const [sort, setSort] = useState(stored.sort || 'relevant');

  function resetFilters() {
    setCurrentPage(1);
    setSelectedCategories([]);
    setSelectedMaterials([]);
    setSearchString('');
    setPremium(false);
    setPrice('all');
    setSort('relevant');
  }

  useEffect(() => {
    const filters = {
      selectedCategories,
      selectedMaterials,
      currentPage,
      premium,
      searchString,
      price,
      sort,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  }, [
    selectedMaterials,
    selectedCategories,
    searchString,
    premium,
    currentPage,
    price,
    sort,
  ]);

  return (
    <FiltersContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        selectedMaterials,
        setSelectedMaterials,
        selectedCategories,
        setSelectedCategories,
        searchString,
        setSearchString,
        premium,
        setPremium,
        price,
        setPrice,
        sort,
        setSort,
        resetFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

function useFilters() {
  const context = useContext(FiltersContext);

  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }

  return context;
}

export { FiltersProvider, useFilters, PRICE_FILTERS, SORT_OPTIONS };
